export const handleFocusableElementKeydown = ({
  event,
  callback,
}: {
  event: KeyboardEvent;
  callback: () => void;
}): void => {
  event.stopPropagation();

  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    callback();
  }
};
